"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortedProviders = void 0;
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useSortedProviders = function () {
    var data = (0, swr_hooks_1.useProviders)().data;
    var config = (0, swr_hooks_1.useConfig)();
    return (0, react_1.useMemo)(function () {
        if (!(config === null || config === void 0 ? void 0 : config.firstShowProviders))
            return data;
        var slugs = (config === null || config === void 0 ? void 0 : config.firstShowProviders) || [];
        var slugSet = new Set(slugs);
        var prioritized = slugs
            .map(function (slug) { return (data || []).find(function (item) { return item.slug === slug; }); })
            .filter(function (item) { return Boolean(item); });
        var rest = (data || []).filter(function (item) { return !slugSet.has(item.slug); });
        return __spreadArray(__spreadArray([], prioritized, true), rest, true);
    }, [config === null || config === void 0 ? void 0 : config.firstShowProviders, data]);
};
exports.useSortedProviders = useSortedProviders;
